import classNames from 'classnames';
import React from 'react';

import ParameterComponent from 'sharedreact/components/ParameterComponent';
import TextInfoField from 'sharedreact/components/TextInfoField';
import TextInput from 'sharedreact/components/TextInput';
import ValidationRules from 'sharedreact/utils/ValidationRules';

type Props = {
  id: string,
  className?: string,
  name: string,
  label: string,
  labelClassName?: string,
  labelTooltip?: string,
  value?: string,
  placeholder?: string,
  maxLength?: number,
  disabled?: boolean,
  readonly?: boolean,
  selected?: boolean,
  validations?: string[],
  type?: string,
  children?: React.ReactNode,
  validationTooltipPlacement?: string,
  validationTooltipClassName?: string,
  autoComplete?: string,
  inputRef?: (element: HTMLInputElement) => void,

  onChangeValue?: (name: string, value: string, event?: React.ChangeEvent<HTMLInputElement>) => void,
  onEnter?: () => void,
  onBlur?: (name: string, value: string, event?: React.FocusEvent<HTMLInputElement>) => void
};

type DefaultProps = Required<Pick<Props, 'value' | 'validations' | 'type' | 'placeholder'>>;

type PropsWithDefaults = Omit<Props, keyof DefaultProps> & DefaultProps;

class TextField extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    value: '',
    validations: [],
    type: 'text',
    placeholder: ''
  };

  override render (): React.ReactNode {
    const { id, className, name, label, labelClassName, labelTooltip,
      value, disabled, readonly, placeholder, validations, type,
      children, onEnter, onBlur, onChangeValue, selected,
      validationTooltipPlacement, validationTooltipClassName, autoComplete,
      inputRef, maxLength
    } = (this.props as PropsWithDefaults);

    let totalValidations = validations;
    if (maxLength != null) {
      totalValidations = validations.concat(ValidationRules.addStringRules(name, maxLength));
    }

    if (readonly) {
      return (
        <TextInfoField
          id={id}
          label={label}
          labelTooltip={labelTooltip}
          value={value}
        />
      );
    }
    return (
      <ParameterComponent
        className={classNames(className, 'esko_parameter-input-max500')}
        label={label}
        labelClassName={labelClassName}
        labelTooltip={labelTooltip}
        inputContainer={!!children}
      >
        <TextInput
          className={classNames({esko_forminput: !children})}
          id={id}
          name={name}
          value={value}
          disabled={disabled}
          selected={selected}
          validations={totalValidations}
          type={type}
          placeholder={placeholder}
          validationTooltipPlacement={validationTooltipPlacement}
          validationTooltipClassName={validationTooltipClassName}
          autoComplete={autoComplete}
          onChangeValue={onChangeValue}
          onEnter={onEnter}
          onBlur={onBlur}
          inputRef={inputRef}
        >
          {children}
        </TextInput>
      </ParameterComponent>
    );
  }
}

export default TextField;
